<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary"
                    @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button class="button btn-danger"
                    v-if="this.element && this.element.id && getPermissionSection('delete')"
                    @click="openConfirmDelete = true">
                {{ $ml.get('buttons.delete') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block" :key="change">
            <div class="title">{{ pageTitle }}</div>
            <div class="body flex-row-wrap">
                <div :class="getClass(label)"
                     v-for="(label, key) in labels">
                    <div class="formBlock">
                        <p :class="['label', {'required' : form_required.includes(label)}]">
                            {{ form_labels[label] }}
                            <template v-if="form_required.includes(label)">*</template>
                        </p>
                        <template v-if="getTypeForm(label) === 'number'">
                            <input type="number"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'string'">
                            <div class="input disabled">
                                <template v-if="element[label]">
                                    {{ element[label] }}
                                </template>
                                <template v-else>
                                    &nbsp;
                                </template>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'date'">
                            <date-picker
                                valueType="format"
                                format="MM/DD/YYYY"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                        </template>
                        <template v-if="getTypeForm(label) === 'datetime'">
                            <date-picker
                                type="datetime"
                                valueType="format"
                                format="MM/DD/YYYY HH:mm:ss"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                        </template>
                        <template v-if="getTypeForm(label) === 'link'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'textarea'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'input'">
                            <input type="text"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="getSelectLabel(label)"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'boolean'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    v-model="element[label]"
                                    :options="selectBooleanOptions"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'custom-select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="typeForm[label].label"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[typeForm[label].dictionary]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-tags'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="helper p10" v-html="helpData"></div>
            </div>
        </div>


        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteForm">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>

<script>
import FormDefault from "../../Utils/Page/FormDefault";
import Table from "../../Utils/Table/Table.vue";

export default {
    name: "QrCodeForm",
    components: {Table},
    mixins: [FormDefault],
    data() {
        return {
            lang: this.$ml.get('pages.qrCode'),
            buttons: [
                { key: 'generate', class: 'btn-primary', function: this.generateCode },
                //{ key: 'generateQRCode', class: 'btn-primary', function: this.generateQRCode }
            ],

            helpData: ``,

            planDiscounts: [],

            typeForm: {
                user_id: 'select',
                artifact_id: 'select',
                hash: 'input',
                activated_at: 'datetime'
            },

            form_required: [
                'hash',
            ],

            element: {
                code: null,
                date_start: null,
                date_finish: null,
                counter: '-',
                activated: true,
            },

            pageRouteList: 'qr_code',
            pageRouteEdit: 'qr_code.edit',
            pageApi: 'marketing.qr_code',
            pagePermission: 'marketing.qr_code',
        }
    },
    methods: {
        setExtraData(data) {

        },
        appendDataSave() {

        },
        generateQRCode() {
            /*this.$store.commit('setLoading', true)
            axios
                .post(
                    this.$store.getters.getApiUrl('marketing.promo_code.getQRCode'),
                    {
                        code: this.element.code,
                    },
                    {
                        responseType: 'blob',
                    }
                )
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'qrcode.png');
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })*/
        },
        generateCode() {
            this.$store.commit('setLoading', true)
            axios
                .post('/api/administrator/qrCode/generateHashForQrCode')
                .then(({data}) => {
                    if (data.success) {
                        this.element.hash = data.hash

                        this.$store.commit('setNotification', {
                            type: 'success',
                            message: 'Code generated'
                        })
                    }
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        setExtraDataCreate() {

        },
        getClass(key) {
            if (['description', 'note'].includes(key)) {
                return 'w50'
            }
            return 'w33'
        },

    },
}
</script>

<style scoped>

</style>
